import { gatsbySSR } from '@lib/ui';
import Theme from './src/theme';

const { onRenderBody, wrapRootElement } = gatsbySSR(Theme);

export { onRenderBody, wrapRootElement };
